// removed by extract-text-webpack-plugin
module.exports = {"container":"Details__container___1PWWu"};